"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var PageTitle = function (_a) {
    var title = _a.title;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: { maxWidth: "400px", margin: "auto", pt: 5 }, children: [(0, jsx_runtime_1.jsx)(Box_1.default, { sx: { textAlign: "center" }, children: (0, jsx_runtime_1.jsx)("img", { src: "/img/logo/dmm_chat_boost/color.svg", alt: "DMM\u30C1\u30E3\u30C3\u30C8\u30D6\u30FC\u30B9\u30C8" }) }), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "h1", component: "h1", sx: { mt: 5, fontWeight: 700, fontSize: "18px", textAlign: "center" }, children: title })] }));
};
exports.PageTitle = PageTitle;
